import React from "react";
import { useWindowDimensions } from "@app/contexts";
import { useTranslation } from "react-i18next";
import { Switch, Case, CaseElse } from "react-context-switch";
import { SideGroupTitle } from "@app/components/groupTitle";
import "./issuer.scss";
import { ContractorEditingGroup } from "@app/components/contractors/formGroupClient";

import Balancer from "react-wrap-balancer";
import { ScrollView } from "devextreme-react";
export const InvoiceIssuerDefinition = () => {
  const { appIsPersonalKarma, jgDrawerHeight } = useWindowDimensions();
  const { t } = useTranslation();
  // if (process.env.REACT_APP_MODE === 'REACT') {
  //   appIsPersonalKarma = true;
  // }

  return (
    // <div
    //   style={{
    //     maxWidth: '1200px',
    //     height: `${jgDrawerHeight}px`,
    //     overflow: 'auto',
    //     margin: 'auto',
    //   }}
    // >
    <ScrollView
      height={`${jgDrawerHeight}px`}
      width={"100%"}
      direction={"vertical"}
      style={{ maxWidth: "1200px", margin: "auto" }}
    >
      <SideGroupTitle title={t("issuerForm")} sideKey={"issuerForm"} />
      <Switch value={appIsPersonalKarma}>
        <Case when={true}>
          <div className="issuer-form">
            <div className="issuer-form-disclaimer">
              <p>
                <Balancer>
                  Aceasta este o &quot;Licenta Individuala&quot; de utilizare a
                  software-ului Jurnal Gold si este subsecventa licentei
                  detinute de Societatatea de Avocatura.
                </Balancer>
              </p>
              <p>
                <Balancer>
                  Licenta permite utilizarea pentru Cabinetul Individual, pentru
                  un singur utilizator si un singur CIF.
                </Balancer>
              </p>
            </div>
            <div className="break" />
            <div className="issuer-form-form">
              <ContractorEditingGroup />
            </div>
            <div className="issuer-form-disclaimer">
              <p>
                <Balancer>
                  Pentru extinderea licentei va rugam sa contactati producatorul
                  Jurnal Gold, Softwiz Creation.
                </Balancer>
              </p>
            </div>
          </div>
        </Case>
        <CaseElse>
          <div className="issuer-form">
            <p>
              {
                "Nu se poate determina forma de licentiere pentru aceasta versiune."
              }
            </p>
          </div>
        </CaseElse>
      </Switch>
    </ScrollView>
  );
};
